export default __webpack_public_path__ + "static/media/linkdin.b7c2fd67.svg";